<template>
  <div :class="{ h5: !isPc, home: true }">
    <!-- <div :class="{ h5: !isPc, home: true }" @click="stopRotation"> -->
    <div
      class="fixed pin-t pin-l pin-r pin-b bg-white text-center"
      style="z-index: -1;line-height:10;"
    >
      内容载入中请稍候....
    </div>
    <a-scene cursor="rayOrigin: mouse;fuse:false;">
      <!-- 全景图 -->
      <a-assets id="imgbox">
        <!-- <img
          v-for="(sky, no) in skies"
          :id="`sky-${no}`"
          :key="no"
          crossorigin="anonymous"
          :src="sky"
          @load="skyLoaded"
        /> -->
      </a-assets>
      <a-sky
        id="skybox"
        :src="defaultSky"
        rotation="0 0 0"
        v-if="!skyLoading"
      />
      <template
        v-if="scenes && scenes.length > 0 && Object.keys(skies).length > 0"
      >
        <a-entity
          v-for="item in scenes.filter(
            item => item.type === 'panorama' && item.visible === 1
          )"
          :id="`group-${item.pano_no}`"
          :key="`scene-${item.pano_no}`"
          :scale="item.pano_no === pano_no ? '1 1 1' : '0 0 0'"
        >
          <template
            v-if="
              item.attributes.entities &&
                item.attributes.entities.length > 0 &&
                item.pano_no === pano_no
            "
          >
            <template v-for="(link, linkIdx) in item.attributes.entities">
              <a-entity
                :key="`group-${linkIdx}`"
                :position="link.position ? link.position : '0 0 0'"
                :rotation="link.rotation ? link.rotation : '0 0 0'"
                :scale="link.scale ? link.scale : '1 1 1'"
                :data-target="link.target"
                v-if="
                  scenes &&
                    scenes.filter(item => item.pano_no === link.target) &&
                    scenes.filter(item => item.pano_no === link.target)[0]
                      .visible === 1
                "
              >
                <a-entity
                  :id="`tag-name-${link.target}`"
                  geometry="primitive:plane;"
                  position="0 1 0"
                  rotation="-15 0 0"
                  scale="2 2 2"
                  :material="
                    `shader:html;target:#name-${
                      link.target
                    };transparent:true;fps:0;ratio:width;side:double;`
                  "
                  :data-target="link.target"
                  @click.stop="switchScene"
                />
              </a-entity>
            </template>
          </template>
          <!-- 输出兴趣点 红圈！ -->
          <template v-if="scene && scene.children">
            <a-entity
              v-for="item in scene.children.filter(
                item =>
                  item.type === 'poi' &&
                  item.visible === 1 &&
                  item.attributes.entity
              )"
              :id="`entity-${item.pano_no}`"
              :key="`entity-poi-${item.pano_no}`"
              geometry="primitive:plane;"
              :position="
                item.attributes &&
                item.attributes.entity &&
                item.attributes.entity.position
                  ? item.attributes.entity.position
                  : '0 0 0'
              "
              :rotation="
                item.attributes &&
                item.attributes.entity &&
                item.attributes.entity.rotation
                  ? item.attributes.entity.rotation
                  : '0 0 0'
              "
              scale="0.2 0.2 0.2"
              :material="
                `shader:html;target:#poi-${
                  item.pano_no
                };transparent:true;fps:0;ratio:width;`
              "
              @click.stop="showPoiFn(item, true)"
            />
          </template>
          <!-- 输出兴趣点 -->
        </a-entity>
      </template>
      <a-entity id="camContainer">
        <a-entity id="cam" camera look-controls>
          <a-cursor id="cursor" color="black" fuse="false" />
        </a-entity>
      </a-entity>
    </a-scene>
    <!-- 生成所有兴趣点的面板 -->
    <template v-for="item in pois">
      <div
        :key="`poi-${item.pano_no}`"
        class="fixed pin-t pin-l"
        style="z-index: -2"
      >
        <div
          :id="`poi-${item.pano_no}`"
          class="text-white rounded-lg flex poi-css"
        ></div>
      </div>
    </template>
    <!-- 生成所有兴趣点的面板 -->
    <!-- 生成所有的名称标签 -->
    <template
      v-for="item in scenes.filter(
        item => item.type === 'panorama' && item.visible === 1
      )"
    >
      <div
        :key="`name-tag-${item.pano_no}`"
        class="fixed pin-t pin-l"
        style="z-index: -2"
      >
        <h1 :id="`name-${item.pano_no}`" class="name-css">
          {{ item.name }}
        </h1>
      </div>
    </template>
    <!-- 生成所有的名称标签 -->
    <!-- 右侧竖向按钮 -->
    <div class="controls fixed text-center">
      <div
        v-if="scene && scene.content && scene.content !== ''"
        class="ctrl relative right-btn"
      >
        <div class="btn-hover" @click.stop="showInfoFn(scene)">
          <i class="btns btns-info inline-block" />
          <span
            class="absolute h-6 leading-none opacity-0 text-center tooltip-css"
          >
            景点介绍
          </span>
        </div>
      </div>
      <OneAudio
        v-if="(briefAudio || detailAudio) && !(briefAudio && detailAudio)"
        :briefAudio="briefAudio"
        :detailAudio="detailAudio"
      ></OneAudio>
      <TwoAudioBar
        v-if="briefAudio && detailAudio"
        class="audio-bar"
        ref="refAudio"
        :briefAudio="briefAudio"
        :detailAudio="detailAudio"
        :showAudio="showModal"
        :data="[briefAudio, detailAudio]"
      />
      <div
        v-if="scene && scene.video"
        class="ctrl relative right-btn navigator-map"
      >
        <!-- <i class="iconfont icon-daohang" aria-hidden="true" /> -->
        <div
          class="btn-hover"
          @click.stop="closeModals('showVideo', !(showModal === 'showVideo'))"
        >
          <i class="btns btns-video inline-block" />
          <span
            class="absolute h-6 leading-none opacity-0 text-center tooltip-css"
          >
            相关视频
          </span>
        </div>
      </div>
      <div
        v-if="
          scene &&
            scene.locations &&
            scene.locations.length > 0 &&
            scene.ceramic_exists
        "
        class="ctrl relative right-btn navigator-map"
      >
        <!-- <i class="iconfont icon-daohang" aria-hidden="true" /> -->
        <div class="btn-hover" @click.stop="openPorcelain">
          <i class="btns btns-porcelain inline-block" />
          <span
            class="absolute h-6 leading-none opacity-0 text-center tooltip-css"
          >
            出土文物
          </span>
        </div>
      </div>
      <div
        v-if="scenes && scenes.length > 0"
        class="ctrl relative right-btn navigator-map"
      >
        <!-- <i class="iconfont icon-daohang" aria-hidden="true" /> -->
        <div
          class="btn-hover"
          @click.stop="closeModals('showNavMap', !(showModal === 'showNavMap'))"
        >
          <i class="btns btns-guide inline-block" />
          <span
            class="absolute h-6 leading-none opacity-0 text-center tooltip-css"
          >
            导览地图
          </span>
        </div>
      </div>
      <div
        v-if="
          scene &&
            scene.models &&
            scene.models.find(item => item.type === 'restored')
        "
        class="ctrl relative right-btn"
      >
        <div class="btn-hover" @click.stop="changeType">
          <i class="btns btns-restore inline-block" />
          <span
            class="absolute h-6 leading-none opacity-0 text-center tooltip-css"
          >
            虚拟复原
          </span>
        </div>
      </div>
      <div class="ctrl relative right-btn return-btn-css">
        <div class="btn-hover" @click.stop="returnFn">
          <i class="btns btns-return inline-block" />
          <span
            class="absolute h-6 leading-none opacity-0 text-center tooltip-css"
          >
            返回
          </span>
        </div>
      </div>
    </div>
    <!-- 右侧竖向按钮 -->
    <!-- 导览图 -->
    <transition name="navMap">
      <div
        v-if="showModal === 'showNavMap' && scenes && scenes.length > 0"
        class="nav-map-img fixed bg-cover bg-no-repeat"
      >
        <div class="navigator-url relative w-full h-full" :style="rootBg">
          <ul
            v-if="
              points && catalogue.navigator_height && catalogue.navigator_width
            "
          >
            <template v-for="point in points">
              <li
                v-if="
                  point.coordinate &&
                    typeof point.coordinate.x === 'number' &&
                    typeof point.coordinate.y === 'number'
                "
                :key="point.id"
                class="point-css absolute cursor-pointer"
                :style="
                  `top:${(point.coordinate.y / catalogue.navigator_height) *
                    100}%; left:${(point.coordinate.x /
                    catalogue.navigator_width) *
                    100}%`
                "
                :data-target="point.pano_no"
                :data-id="point.id"
                @click.stop="switchScene"
              >
                <div
                  :data-target="point.pano_no"
                  :data-id="point.id"
                  v-if="scene.id === point.id"
                  class="loader-inner ball-scale-ripple-multiple"
                >
                  <div :data-target="point.pano_no" :data-id="point.id"></div>
                  <div :data-target="point.pano_no" :data-id="point.id"></div>
                  <div :data-target="point.pano_no" :data-id="point.id"></div>
                </div>
              </li>
            </template>
          </ul>
        </div>
        <i
          class="iconfont icon-close cursor-pointer text-center absolute"
          aria-hidden="true"
          @click.stop="closeModals('showNavMap', !(showModal === 'showNavMap'))"
        />
      </div>
    </transition>
    <!-- 遮罩层 -->
    <div @click.stop="closeModals('showNavMap', !(showModal === 'showNavMap'))">
      <Masker :data="showModal === 'showNavMap'"></Masker>
    </div>
    <!-- 遮罩层 -->
    <!-- 导览图 -->
    <!-- 简介 -->
    <InfoBar :show="showModal === 'showInfo'" :data="infoData" />
    <!-- 简介 -->
    <!-- poi简介 -->
    <InfoBar class="poi-info" :show="showModal === 'showPoi'" :data="poiData" />
    <!-- poi简介 -->
    <!-- 视频 -->
    <VideoPlayer
      v-if="showModal === 'showVideo'"
      class="video"
      :data="scene.video"
      :autoplay="true"
      :show="showModal === 'showVideo'"
      type="video"
    />
    <!-- 视频 -->
    <!-- 缩略图 -->
    <Thumbnail
      :show.sync="showDrawer"
      :data="
        scenes.filter(item => item.type === 'panorama' && item.visible === 1)
      "
      :active="scene"
    />
    <!-- 缩略图 -->
  </div>
</template>

<script>
import AFRAME from 'aframe'
import 'aframe-event-set-component'
import 'aframe-look-at-component'
import 'aframe-html-shader'
import InfoBar from '@/components/InfoBar'
import TwoAudioBar from '@/components/TwoAudioBar'
import OneAudio from '@/components/OneAudioBar'
import Thumbnail from '@/components/Thumbnail'
import Masker from '@/components/common/Mask'
// import Player from '@/components/common/Player'
import VideoPlayer from '@/components/common/VideoPlayer'

export default {
  name: 'Home',
  components: {
    InfoBar,
    TwoAudioBar,
    OneAudio,
    Thumbnail,
    Masker,
    // Player,
    VideoPlayer
  },
  data() {
    return {
      registed: false,
      inteval: null,
      timeout: null,
      defaultRotationDegree: 0,
      cammeraRotation: 0,
      cammeraBoxRotation: 0,
      pano_no: null,
      type: 'current',
      catalogue: null,
      scenes: [],
      skyLoading: true,

      showModal: null,
      // modals: ['showNavMap', 'showInfo', 'showAudio', 'showVideo', 'showPoi'], // 导览图 简介 音频 视频 出土文物 poi简介
      showDrawer: true, // 显示缩略图
      infoData: null,
      poiData: null

      // audioBtn: 0 // 音频按钮
    }
  },
  computed: {
    points() {
      return this.catalogue.children.filter(
        item => item.type === 'panorama' && item.visible === 1
      )
    },
    rootBg() {
      let thisStyle =
        this.catalogue.navigator_width > this.catalogue.navigator_height
          ? `background-image: url('${
              this.catalogue.navigator_url ? this.catalogue.navigator_url : ''
            }');width:26rem;height: ${(26 / this.catalogue.navigator_width) *
              this.catalogue.navigator_height}rem`
          : `background-image: url('${
              this.catalogue.navigator_url ? this.catalogue.navigator_url : ''
            }');width:22rem;height: ${(22 / this.catalogue.navigator_width) *
              this.catalogue.navigator_height}rem`

      return thisStyle
    },
    rotationDegree() {
      return -(
        this.defaultRotationDegree +
        this.cammeraRotation +
        this.cammeraBoxRotation
      )
    },
    scene() {
      if (this.pano_no && this.scenes && this.scenes.length > 0) {
        // // eslint-disable-next-line no-console
        // console.log(this.scenes.find(item => item.pano_no === this.pano_no))
        return this.scenes.find(item => item.pano_no === this.pano_no)
      }
      return { children: [] }
    },
    panoramas() {
      return this.$store.getters['PanoramasStore/panoramas']
    },
    skies() {
      if (this.scenes && this.scenes.length > 0) {
        return this.scenes
          .filter(item => item.type === 'panorama' && item.visible === 1)
          .reduce((result, item) => {
            let current = item.models.find(item => item.type === 'current')
            let restored = item.models.find(item => item.type === 'restored')
            if (current) {
              result[`${item.pano_no}-current`] = current.path_url
            }
            if (restored) {
              result[`${item.pano_no}-restored`] = restored.path_url
            }
            // // eslint-disable-next-line no-console
            // console.log(result)
            return result
          }, {})
      }
      return {}
    },
    pois() {
      if (
        this.catalogue &&
        this.catalogue.children &&
        this.catalogue.children.length > 0
      ) {
        let scenes = this.catalogue.children.filter(
          item => item.type === 'panorama' && item.visible === 1
        )
        let poiArr = scenes.reduce((result, item) => {
          return result.concat(
            item.children.filter(
              item =>
                item.type === 'poi' &&
                item.visible === 1 &&
                item.attributes.entity
            )
          )
        }, [])
        // // eslint-disable-next-line no-console
        // console.log(poiArr)
        return poiArr
      }
      return []
    },
    defaultSky() {
      if (this.pano_no) {
        return `#sky-${this.pano_no}-${this.type}`
      }
      return ''
    },
    detailAudio() {
      if (!this.scene || !this.scene.models || this.scene.models.length === 0) {
        return false
      }
      // eslint-disable-next-line no-console
      // console.log(
      //   this.scene.models.filter(modal => {
      //     return modal.type === 'detail'
      //   })[0]
      // )
      return this.scene.models.filter(modal => {
        return modal.type === 'detail'
      })[0]
    },
    briefAudio() {
      // eslint-disable-next-line no-console
      // console.log(this.$refs)
      if (!this.scene || !this.scene.models || this.scene.models.length === 0) {
        return false
      }
      // eslint-disable-next-line no-console
      // console.log(
      //   this.scene.models.filter(modal => {
      //     return modal.type === 'brief'
      //   })[0]
      // )
      return this.scene.models.filter(modal => {
        return modal.type === 'brief'
      })[0]
    },
    isPc() {
      let res = this.$store.getters['IsPcStore/isPc']
      return res
    }
  },
  watch: {
    panoramas: {
      immediate: true,
      // 当panoramas数据准备好的时候
      handler: function(val) {
        // // eslint-disable-next-line no-console
        // console.group('panoramas', val)
        if (typeof val === 'object' && Object.values(val).length > 0) {
          let flatten = function(into, node) {
            if (node == null) return into
            if (Array.isArray(node)) return node.reduce(flatten, into)
            into.push(node)
            return flatten(into, node.children)
          }
          this.scenes = flatten([], Object.values(val))
          // // eslint-disable-next-line no-console
          // console.log('获取全部场景', this.scenes)
        }
        // 如果这是一个带有查询字符串的请求，那么使用参数pano_no的值去寻找
        if (
          (this.$route.query.pano_no &&
            typeof this.$route.query.pano_no === 'string') ||
          (this.$route.query.id && typeof this.$route.query.id === 'string')
        ) {
          this.pano_no = this.$route.query.pano_no
          if (!this.pano_no) {
            let found = this.scenes.find(
              item => item.id === this.$route.query.id
            )
            this.pano_no = found.pano_no
          }
          // eslint-disable-next-line no-console
          console.log('当前的场景NO', this.pano_no)
          this.$nextTick(() => {
            this.createImg(this.pano_no)
          })
          if (typeof val === 'object' && Object.values(val).length > 0) {
            const root = Object.values(val)[0]
            var findCatalogue = function(obj, no) {
              let result = obj.children.find(item => item.pano_no === no)

              if (result) {
                return obj
              } else {
                for (let item of obj.children) {
                  // console.log(item.pano_no)
                  result = findCatalogue(item, no)
                  if (result) {
                    // console.log('找到了', { no: item.pano_no })
                    return result
                  }
                }
              }
              return null
            }
            let result = findCatalogue(root, this.pano_no)
            // // eslint-disable-next-line no-console
            // console.log('找到节点', result)
            if (result) {
              this.catalogue = result
            } else {
              this.exception = '无法找到指定的场景'
            }
            // eslint-disable-next-line no-console
            console.groupEnd()
            return
          }
        } else {
          // 如果没有设置第一个场景的ID，那么取根节点作为起始场景
          if (typeof val === 'object' && Object.values(val).length > 0) {
            const items = Object.values(val)
            let result = items[0].children.find(
              item => item.type === 'panorama' && item.visible === 1
            )
            if (result) {
              this.pano_no = result.pano_no
              this.catalogue = items[0]
              this.$nextTick(() => {
                this.createImg(this.pano_no)
              })

              return
            } else {
              this.exception = '当前场景数据为空'
              return
            }
          }
          this.exception = '场景数据接口异常'
        }
        // eslint-disable-next-line no-console
        console.groupEnd()
      }
    },
    scenes() {
      // 把导览图阴影的朝向归零
      // this.defaultRotationDegree = 0
      // this.cammeraRotation = 0
      // this.cammeraBoxRotation = 0
    }
  },
  created() {
    try {
      let _this = this
      AFRAME.registerComponent('camera-rotation-reader', {
        tick: function() {
          var rotation = this.el.getAttribute('rotation')
          if (_this.cammeraRotation !== rotation['y']) {
            // console.log(rotation)
            _this.cammeraRotation = rotation['y']
          }
        }
      })
    } catch (e) {
      console.info(e) // eslint-disable-line no-console
    }
  },
  mounted() {
    this.primaryEvent()
    // this.autoRotation()
    // // eslint-disable-next-line no-console
    // console.log({
    //   scenes: this.scenes,
    //   panoramas: this.panoramas,
    //   skies: this.skies,
    //   pano_no: this.pano_no
    // })
  },
  methods: {
    primaryEvent() {
      // let _this = this
      /*注册滚轮事件*/
      if (document.addEventListener) {
        //W3C FF
        document.addEventListener('DOMMouseScroll', this.zoom, false)
      }
      //IE/Opera/Chrome/Safari
      window.onmousewheel = document.onmousewheel = this.zoom

      // // 注册键盘事件
      // document.onkeydown = function() {
      //   {
      //     if (event.keyCode == 37) {
      //       //左
      //       _this.rotation('y', 0.4)
      //     }
      //     if (event.keyCode == 38) {
      //       //上
      //       _this.rotation('x', 0.4)
      //     }
      //     if (event.keyCode == 39) {
      //       //右
      //       _this.rotation('y', -0.4)
      //     }
      //     if (event.keyCode == 40) {
      //       //下
      //       _this.rotation('x', -0.4)
      //     }
      //   }
      // }
    },
    // autoRotation() {
    //   let _this = this
    //   let camera = document.querySelector('#camContainer')
    //   let rotation = camera.getAttribute('rotation')
    //   if (this.timeout) {
    //     return false
    //   }
    //   this.timeout = setTimeout(() => {
    //     clearTimeout(this.timeout)
    //     if (!_this.inteval) {
    //       rotation.x = 0
    //       _this.inteval = setInterval(() => {
    //         if (_this.skyLoading) {
    //           return
    //         }
    //         rotation['y'] -= 0.15
    //         _this.cammeraBoxRotation = rotation['y']
    //         camera.setAttribute('rotation', rotation)
    //       }, 50)
    //     } else {
    //       clearInterval(_this.inteval)
    //       _this.inteval = null
    //     }
    //   }, 5000)
    // },
    // stopRotation() {
    //   clearInterval(this.inteval)
    //   this.inteval = null
    //   clearTimeout(this.timeout)
    //   this.timeout = null
    //   this.autoRotation()
    // },
    // rotation(axis, diff) {
    //   let sky = document.querySelector('#camContainer')
    //   let rotation = sky.getAttribute('rotation')
    //   // console.log(rotation)
    //   rotation[axis] += diff
    //   sky.setAttribute('rotation', rotation)
    // },
    // resetOrientation() {
    //   let camera = document.querySelector('#camContainer')
    //   clearInterval(this.inteval)
    //   this.inteval = null
    //   camera.setAttribute('rotation', { x: 0, y: 0, z: 0 })
    //   this.cammeraBoxRotation = 0

    //   camera = document.querySelector('#cam')
    //   let attr = camera.getAttribute('camera')
    //   attr.zoom = 1
    //   camera.setAttribute('camera', attr)
    // },
    zoom(e) {
      // e是FF的事件。window.event是chrome/ie/opera的事件
      var ee = e || window.event
      let delta
      // // eslint-disable-next-line no-console
      // console.log(ee) //可以看看ee.wheelDelta和e.detail在浏览器中的值；
      if (ee.wheelDelta > 0 || ee.detail > 0) {
        delta = 0.05
      } else {
        delta = -0.05
      }

      let camera = document.querySelector('#cam')
      let attr = camera.getAttribute('camera')
      if (attr.zoom + delta > 0.79 && attr.zoom + delta < 1.51) {
        attr.zoom += delta
        camera.setAttribute('camera', attr)
      }
      // // eslint-disable-next-line no-console
      // console.log(attr.zoom)
    },
    skyLoaded() {
      this.skyLoading = false
    },
    createImg(no) {
      // 分步加载图片 start-------------
      let imbox = document.querySelector('#imgbox')
      // // eslint-disable-next-line no-console
      // console.log(no, imbox)
      let thisImg = this.scenes.find(item => item.pano_no == no)
      if (thisImg) {
        let inner = ''
        let current = thisImg.models.find(item => item.type === 'current')
        let restored = thisImg.models.find(item => item.type === 'restored')
        if (current) {
          inner = `<img id="sky-${
            thisImg.pano_no
          }-current" key="no" crossorigin="anonymous" src="${
            current.path_url
          }" />`
        }
        if (restored) {
          inner += `<img id="sky-${
            thisImg.pano_no
          }-restored" key="no" crossorigin="anonymous" src="${
            restored.path_url
          }" />`
        }
        imbox.innerHTML = inner
        imbox.onload = this.skyLoaded()
      }

      // 分步加载图片 end-------------
    },
    switchScene(e) {
      // // eslint-disable-next-line no-console
      // console.log('switchScene', e)
      if (this.$route.hash === '#debug') {
        return
      }
      const target = e.target.dataset ? e.target.dataset.target : e.target
      // eslint-disable-next-line no-console
      console.log('即将跳转到场景：' + target)

      this.createImg(target)

      this.type = 'current'
      this.pano_no = target
      let parent = document.querySelector('#camContainer')
      parent.innerHTML =
        '<a-entity id="cam" camera look-controls><a-cursor id="cursor" color="black" fuse="false" /></a-entity>'
      let rotation = parent.getAttribute('rotation')
      rotation.y = 0
      parent.setAttribute('rotation', rotation)
      // this.closeModals('showNavMap', !(this.showModal === 'showNavMap'))
      // this.stopRotation()
    },
    showInfoFn(item) {
      this.closeModals('showInfo', !(this.showModal === 'showInfo'))
      if (this.showModal === 'showInfo') {
        this.infoData = item
      }
    },
    showPoiFn(item, val) {
      // if (!(item && item.content && item.content !== '')) {
      //   return false
      // }
      this.closeModals('showPoi', val)
      if (this.showModal === 'showPoi') {
        this.poiData = item
      }
    },
    changeType() {
      this.$set(this, 'type', this.type === 'current' ? 'restored' : 'current')
    },
    openPorcelain() {
      let url = `${process.env.VUE_APP_WWW_ENDPOINT}ceramic`
      let query
      if (this.scene && this.scene.locations.length > 0) {
        query = `?location=${this.scene.locations.join('&location=')}`
      }
      window.open(url + query)
    },
    returnFn() {
      if (!this.scene) {
        return false
      }
      let depth = this.scene.depth
      let pid = this.scene.parent_id

      if (depth === 1 || depth === '1') {
        top.location.href = `${process.env.VUE_APP_WWW_ENDPOINT}panorama`
      } else {
        if (!this.scenes && this.scenes.length === 0) {
          return false
        }
        let arr = this.scenes.filter(item => item.id === pid)

        if (arr.length > 0) {
          this.$router.push({
            query: {
              pano_no: arr[0].pano_no
            }
          })
          this.$router.go(0)
        }
      }
    },
    closeModals(val, bool) {
      if (bool) {
        this.showModal = val
      } else {
        this.showModal = null
      }
    }
  },
  destroyed() {
    console.info('destroyed') // eslint-disable-line no-console
    clearInterval(this.inteval)
    this.inteval = null
  }
}
</script>
<style lang="scss">
.navMap-enter-active,
.navMap-leave-active {
  transition: all 0.35s;
  -moz-transition: all 0.35s; /* Firefox 4 */
  -webkit-transition: all 0.35s; /* Safari 和 Chrome */
  -o-transition: all 0.35s; /* Opera */
}
.navMap-enter, .navMap-leave-to/* .drawer-leave-active below version 2.1.8 */ {
  opacity: 0;
}
// 按钮样式
.btns {
  width: 2.75rem;
  height: 2.75rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
}

.btns-info {
  background-image: url('../../public/images/btns/info.png');
}
.btns-video {
  background-image: url('../../public/images/btns/video.png');
}
.btns-audio0 {
  background-image: url('../../public/images/btns/audio.png');
}
.btns-audio-active {
  background-image: url('../../public/images/btns/audio.gif');
}
.btns-loading {
  border: 1.3px solid #fff;
  background-color: rgba(0, 0, 0, 0.6);
  background-size: 70% 70%;
  background-image: url('../../public/images/loading.gif');
}
.btns-audio1 {
  background-image: url('../../public/images/btns/audio1.png');
}
.btns-audio2 {
  background-image: url('../../public/images/btns/audio2.png');
}
.btns-porcelain {
  background-image: url('../../public/images/btns/porcelain.png');
}
.btns-guide {
  background-image: url('../../public/images/btns/guide.png');
}
.btns-restore {
  background-image: url('../../public/images/btns/restore.png');
}
.btns-return {
  background-image: url('../../public/images/btns/return.png');
}

// 导览图样式
.nav-map-img {
  top: 10%;
  left: 50%;
  margin-left: -10rem;
  z-index: 101;
}
.icon-close {
  top: 0;
  right: -2.75rem;
  width: 2.75rem;
  height: 2.75rem;
  line-height: 2.75rem;
  // border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 1.8rem;
  color: #fff;
  &:hover {
    opacity: 0.6;
  }
}

.navigator-url {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
.point-css {
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background-color: #cf3132;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}
// 动画
.ball-scale-ripple-multiple {
  position: absolute;
  bottom: -5px;
  left: -10px;

  -webkit-transform: translateY(-25px);
  -ms-transform: translateY(-25px);
  transform: translateY(-25px);
  > div {
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    border: 2px solid #cf3132;
    -webkit-animation: ball-scale-ripple-multiple 1.25s 0s infinite
      cubic-bezier(0.21, 0.53, 0.56, 0.8);
    animation: ball-scale-ripple-multiple 1.25s 0s infinite
      cubic-bezier(0.21, 0.53, 0.56, 0.8);
    &:nth-child(1) {
      -webkit-animation-delay: 0s;
      animation-delay: 0s;
    }
    &:nth-child(2) {
      -webkit-animation-delay: 0.2s;
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      -webkit-animation-delay: 0.4s;
      animation-delay: 0.4s;
    }
  }
}
@keyframes ball-scale-ripple-multiple {
  0% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}

// 右侧竖向按钮
.controls {
  top: 3rem;
  right: 1.3rem;
  width: 3rem;
  font-size: 0;
  .ctrl {
    margin-top: 0.75rem;
    border-radius: 50%;
  }
}
.ctrl {
  color: #fff;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  i {
    font-size: 1.125rem;
  }
  &:hover {
    opacity: 0.7;
  }
}
.audio-bar {
  z-index: 101;
}
.btn-hover {
  &:hover {
    .tooltip-css {
      transition: all 0.35s;
      -moz-transition: all 0.35s;
      /* Firefox 4 */
      -webkit-transition: all 0.35s;
      /* Safari 和 Chrome */
      -o-transition: all 0.35s;
      /* Opera */
      opacity: 1;
    }
  }
}
.h5.home {
  .btn-hover {
    &:hover {
      .tooltip-css {
        opacity: 0;
      }
    }
  }
}
.tooltip-css {
  width: 4.4rem;
  background-color: rgba(0, 0, 0, 0.9);
  font-size: 0.8rem;
  z-index: 10;
  left: -5rem;
  top: 0.7rem;
  padding: 0.3rem 0 0.3rem 0;
  border-radius: 2px;
  i {
    width: 0.375rem;
    height: 0.375rem;
    background-color: rgba(0, 0, 0, 0.9);
    margin-bottom: 0.125rem;
    margin-right: -1.1rem;
    transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    /* IE 9 */
    -webkit-transform: rotate(45deg);
    /* Safari and Chrome */
    -o-transform: rotate(45deg);
    /* Opera */
    -moz-transform: rotate(45deg);
    /* Firefox */
  }
}
.h5 {
  .navigator-map {
    display: none;
  }
}
// 视频样式
.video {
  width: 60%;
  height: auto;
  position: fixed;
  top: 10%;
  left: 20%;
}
// 兴趣点样式
.poi-css {
  width: 2rem;
  height: 2rem;
  background-size: 1.5rem 1.5rem;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('../../public/images/btns/poi.png');
}
.name-css {
  font-size: 4rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 0.3rem 0.8rem 0.7rem 0.8rem;
  border-radius: 4px;
}
@media only screen and (min-width: 736px) {
}
@media only screen and (max-width: 735px) {
  .return-btn-css {
    display: none;
  }
}
</style>
